import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, GoogleAuthProvider, signInWithPopup, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Validate Firebase config
const requiredKeys = ['apiKey', 'authDomain', 'projectId'];
const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);

if (missingKeys.length > 0) {
  console.error('Missing Firebase configuration:', missingKeys);
  throw new Error(`Missing Firebase configuration keys: ${missingKeys.join(', ')}`);
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export { firebaseApp };

// Initialize auth providers
export const googleProvider = new GoogleAuthProvider();

export const firebaseAuth = {
  signup: (email, password) =>
    createUserWithEmailAndPassword(auth, email, password),

  login: (email, password) =>
    signInWithEmailAndPassword(auth, email, password),

  loginWithGoogle: () =>
    signInWithPopup(auth, googleProvider),

  loginWithPhone: (phoneNumber, recaptchaVerifier) =>
    signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier),

  logout: () =>
    signOut(auth),

  getCurrentUser: () =>
    auth.currentUser,

  setupRecaptcha: (containerId) =>
    new RecaptchaVerifier(auth, containerId, {
      size: 'invisible',
      callback: (response) => {

      },
      'expired-callback': () => {

      }
    })
};

export default firebaseApp;